import AuthNetworkBackground from './AuthNetworkBackground.jsx'
import Logo from './Logo.jsx'

const DEFAULT_STATS = [
  ['6.9x', 'ROAS médio'],
  ['R$9', 'CPL médio'],
  ['27%', 'Taxa LQ'],
]

export default function AuthShowcase({
  title,
  description,
  stats = DEFAULT_STATS,
  variant,
}) {
  if (variant === 'titam') return (
    <aside className="auth-left auth-titam" aria-label="Conheça a TITAM">
      <div className="auth-titam-glow" aria-hidden="true" />
      <AuthNetworkBackground />
      <div className="auth-titam-brand"><Logo height={24} /><span>Conecte. Organize. Cresça.</span></div>
      <div className="auth-titam-message">
        <span className="auth-titam-eyebrow">Seu próximo passo começa aqui</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </aside>
  )
  return (
    <div className="auth-left">
      <div className="auth-left-pattern" />
      <div className="auth-left-content">
        {/* Painel de fundo preto: a logo (preta sobre transparente) vai invertida. */}
        <div className="auth-brand">
          <Logo height={18} invert />
        </div>
        <div>
          <div className="auth-headline">{title}</div>
          <div className="auth-sub">{description}</div>
        </div>
      </div>

      <div className="auth-stats">
        {stats.map(([value, label]) => (
          <div key={label}>
            <div className="auth-stat-val">{value}</div>
            <div className="auth-stat-label">{label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
